import { QuestionBase } from '@app/core/models/question/question-base';

export class SliderQuestion extends QuestionBase<string> {
  controlType = 'slider';
  options: {
    range: {
      min: number,
      max: number
    },
    defaultValue: number,
    step: number,
    type: string,
    unit?: string,
    labels?: { content: string, color: string }[],
    showLabels?: boolean,
    showTicks?: boolean,
    showTrack?: boolean,
  };

  constructor(options: any = {}) {
    super(options);
    this.options = options['options'];
  }
}



// WEBPACK FOOTER //
// ./src/app/core/models/question/slider-question.ts